/* src/app/user-default/ticket/edit-ticket/edit-ticket.component.scss */
.paperclip {
  width: 24px;
  height: 24px;
}
.paperclip img {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=edit-ticket.component-KVWGX2KF.css.map */
